import { Injectable } from '@angular/core';
import { LoginService } from '../login/login.service';
@Injectable({
  providedIn: 'root'
})
export class PaginadorService {
  private llavePaginador = this.loginService.usuario.empresa_seleccionada.id + '-Paginador';
  private paginador = JSON.parse(localStorage.getItem(this.llavePaginador) + '') as PaginadorObject;
  constructor(public loginService: LoginService) {

  }
  public getBusquedaCatalogo(tituloBusqueda: string): PageBusquedaObject {
    if (this.paginador == undefined || this.paginador.pageBusquedaObject[tituloBusqueda] == undefined) {
      
      this.setBusquedaCatalogo(tituloBusqueda, new PageBusquedaObject())
    }
    return this.paginador.pageBusquedaObject[tituloBusqueda] as PageBusquedaObject;
  }
  public setBusquedaCatalogo(tituloBusqueda: string, busqueda: PageBusquedaObject): void {
    if (this.paginador == undefined || this.paginador.pageBusquedaObject[tituloBusqueda] == undefined) {
      this.paginador = new PaginadorObject();
    }
    busqueda.page1 = true;
    this.paginador.pageBusquedaObject[tituloBusqueda] = busqueda;
    localStorage.setItem(this.llavePaginador, JSON.stringify(this.paginador));
  }

  public borrarBusquedas() {
    this.paginador = new PaginadorObject();
    localStorage.setItem(this.llavePaginador, JSON.stringify(this.paginador));
  }



}
export class PaginadorObject {
  pageBusquedaObject?: any | undefined = {};
}
@Injectable({
  providedIn: 'root'
})
export class PageBusquedaObject {
  column?: string | undefined = '';
  criteriaSearch?: any | undefined = {};
  itemsPerPage?: number | undefined = 10;
  order?: string | undefined = '';
  pageNumber?: number = 1;
  sort?: boolean | undefined = false;
  page1?: boolean | undefined = true;
}